import React, { useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch } from 'react-redux'
import { getVideoLookCamera } from '../../actions/videoRecords'
import Loader from '../../components/Loader'
import styles from './Modal.module.css'

export default function VideoModal({ record, open, closeModal }) {
  const dispatch = useDispatch()
  const [cameraData, setCameraData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (record && open && record.cam_id) {
      setLoading(true)
      setError(null)
      setCameraData(null)

      dispatch(getVideoLookCamera(record.cam_id))
        .then(data => {
          setCameraData(data)
          setLoading(false)
        })
        .catch(err => {
          console.error('Error loading video:', err)
          setError('Не удалось загрузить видео')
          setLoading(false)
        })
    } else {
      setCameraData(null)
      setError(null)
    }
  }, [record, open])

  const handleClose = () => {
    setCameraData(null)
    setError(null)
    closeModal()
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      center
      classNames={{ modal: styles.modal }}
    >
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2>Видеозапись</h2>
          {record && (
            <div className={styles.recordInfo}>
              <p><strong>Дата:</strong> {new Date(record.recording_date).toLocaleDateString('ru-RU')}</p>
              <p><strong>Урок:</strong> {record.lesson_number}</p>
              <p><strong>Кабинет:</strong> {record.room_name}</p>
              <p><strong>Преподаватель:</strong> {record.teacher_name}</p>
              <p><strong>Класс:</strong> {record.class_name}</p>
              <p><strong>Предмет:</strong> {record.subject_name}</p>
            </div>
          )}
        </div>

        <div className={styles.videoContainer}>
          {loading && <Loader />}
          {error && <div className={styles.error}>{error}</div>}
          {cameraData && cameraData.url && !loading && (
            <video
              controls
              autoPlay
              className={styles.videoPlayer}
              src={cameraData.url}
            >
              Ваш браузер не поддерживает воспроизведение видео.
            </video>
          )}
        </div>
      </div>
    </Modal>
  )
}

